import Brand from "../../components/index/indexone/Brand";

export default function OurDeployments() {
  return (
    <section className="shop-area black-bg pt-80 pb-30">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-8">
            <div className="section-title title-style-three white-title text-center mb-40">
              <h2>
                Our <span>Partners</span>
              </h2>
              <p>
                We collaborate with industry leaders to bring world-class gaming
                experiences.Together, we build, grow, and innovate.
              </p>
            </div>
          </div>
        </div>
        <Brand />
      </div>
    </section>
  );
}
